import React from "react";
import { Reveal } from "@/components/effects/Reveal";
import { UserPlus, Coins, FolderHeart, Download } from "lucide-react";

const STEPS = [
  { icon: UserPlus, title: "Register", desc: "Create your private WelkomBiz customer account." },
  { icon: Coins, title: "Receive Credits", desc: "Credits are issued per event so you only pay for what you need." },
  { icon: FolderHeart, title: "Browse & Select", desc: "Open your event gallery, mark favourites, add to cart." },
  { icon: Download, title: "Download Originals", desc: "Credits unlock full-quality, watermark-free files." },
];

export const HowCreditsWork = () => {
  return (
    <section data-testid="credits-section" className="relative py-28 sm:py-36 bg-[#050507]">
      <div className="absolute inset-x-0 top-0 glow-line-cy opacity-40" />
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">— How Photo Credits Will Work</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
                <span className="text-chrome">A premium way to</span>{" "}
                <span className="italic text-magcyan">own your moments</span>
                <span className="text-chrome">.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={220}>
            <p className="max-w-md text-white/60 font-body leading-relaxed">
              Customers will be able to register, receive credits, browse event photos,
              add selected images to their cart, and download high-quality originals
              once credits are used.
            </p>
          </Reveal>
        </div>

        <div className="relative">
          <div className="absolute top-12 left-0 right-0 h-px hidden lg:block"
            style={{ background: "linear-gradient(90deg, transparent, rgba(255,46,147,0.6), rgba(24,211,255,0.6), transparent)" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={i * 120}>
                <div className="relative glass chrome-border rounded-md p-7 h-full lift">
                  <div className="absolute -top-3 left-7 text-[10px] tracking-luxe uppercase px-2.5 py-1 rounded-full bg-black border border-white/10 text-white/60">
                    Step {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="w-12 h-12 rounded-full flex items-center justify-center chrome-border bg-black/40 mb-5 mt-3">
                    <s.icon className="w-4.5 h-4.5 text-white" />
                  </div>
                  <h3 className="font-display text-2xl text-chrome mb-2">{s.title}</h3>
                  <p className="text-sm text-white/55 font-body leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={520}>
          <p className="mt-10 text-center text-[11px] tracking-luxe uppercase text-white/40">
            The credit system unlocks in a future phase — design preview only.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default HowCreditsWork;
